import { Link, useNavigate } from 'react-router-dom';
import './Header.scss';
import Path from '../Path/Path';
import useAuth from '../../hooks/useAuth';


export default function Header() {
    const navigate = useNavigate();
    const authenticated = useAuth();


    const goBack = () => {
        navigate(-1);
    };

    return (
        <div id="header">

            <div className='left'>
                <Link to="" onClick={goBack} className="header-link logo"> &lt; </Link>
                <Link to="/" className="header-link logo"> Ratonera.net </Link>
            </div>

            <div className='header-links rigth'>
                {authenticated ?
                    <Link to="/profile" className="header-link"> Profile </Link>
                    :
                    <Link to="/login" className="header-link"> Login </Link>
                }
            </div>
        </div>
    );
}